import React from "react";

import { Desktop, Mobile, V3 } from "./views";
import { useContent } from "src/hooks";

export const MarketSumComponent = React.memo(() => {
  const content = useContent();

  let view;

  switch (content) {
    case "desktop":
      view = <Desktop />;
      break;
    case "mobile":
    case "laptop":
      view = <Mobile />;
      break;
    case "v3":
      view = <V3 />;
      break;
    default:
      view = null;
  }

  return view;
});

MarketSumComponent.displayName = "MarketSumComponent";
